import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=933fc9d2&scoped=true&"
import script from "./Language.vue?vue&type=script&lang=js&"
export * from "./Language.vue?vue&type=script&lang=js&"
import style0 from "./Language.vue?vue&type=style&index=0&id=933fc9d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933fc9d2",
  null
  
)

export default component.exports